import { Box, Grid } from '@mantine/core';
import { ReactNode } from 'react';
import { WidgetOpenAlerts } from 'components/Widgets/WidgetOpenAlerts';
import { WidgetTotalActivePatients } from 'components/Widgets/WidgetTotalActivePatients';
import { WidgetTotalPatients } from 'components/Widgets/WidgetTotalPatients';
import { showWorklistFeature } from 'utils/app';

export interface WidgetModel {
  componentName: string;
  order: number;
  component: ReactNode;
  size: number;
  enabled: boolean;
}

export const Dashboard = () => {
  return (
    <Box>
      <Grid>
        <Grid.Col span={showWorklistFeature ? 6 : 8}>
          <Grid>
            <Grid.Col span={12}>{showWorklistFeature ? <WidgetOpenAlerts /> : null}</Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={6}>
              <WidgetTotalPatients />
            </Grid.Col>
            <Grid.Col span={6}>
              <WidgetTotalActivePatients />
            </Grid.Col>
          </Grid>
        </Grid.Col>
      </Grid>
    </Box>
  );
};
